// Copyright (c) 2015, Intelligent IoT Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
cx._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = cx._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = cx._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = cx._;

cx.get_languages = function () {
	if (!cx.languages) {
		cx.languages = [];
		$.each(cx.boot.lang_dict, function (lang, value) {
			cx.languages.push({ label: lang, value: value });
		});
		cx.languages = cx.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return cx.languages;
};
